import React, { useState } from "react";
import { Page } from "./model";
import "./App.css";
import { Container, Modal, Button } from "react-bootstrap";
import { taskListType , taskListType15 } from "./api/newApi/getTaskList";
// import trad_banner from './static/image/trad_banner_h1.png';

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Navigation from "./container/Navigation";
import GameIndex from "./container/GameIndex";
import Account from "./container/Account";
import Order from "./container/Order";
import OrderInquire from "./container/OrderInquire";
import Leaderboard from "./container/Leaderboard";
import SelfSelect from "./container/SelfSelect";
import Profited from "./container/Profited";
import Verify from "./container/Verify";

import { useAsyncRetry, useAsync } from "react-use";
import api from "./api";
import { CampaignType } from "./api/newApi/getCampaignQuery";
import dayjs from "dayjs";

import { connectOrderWebSocket } from "./websocket/order";
import {
  connectQuoteWebSocket,
  SessionIdSubject as QuoteSessionIdSubject,
  HeartbeatSubject as QuoteHeartbeatSubject,
} from "./websocket/quote";

import { merge, tap } from "rxjs";
import { timeout } from "rxjs/operators";
import { OrderReportMessageSubject, HeartbeatSubject } from "./websocket/order";

function useConnectOrderSocket(
  cuid: string | null,
  campaignName: string | null,
  wsOrderdisConnect: boolean,
  handleOrderConnect: (state: boolean) => void
) {
  const handleRef = React.useRef(handleOrderConnect);
  handleRef.current = handleOrderConnect;
  React.useEffect(() => {
    const TIMEOUT_DURATION = 15 * 1000;
    if (!cuid || !campaignName) {
      return;
    }
    const socket = connectOrderWebSocket({
      url: `${process.env.REACT_APP_URL}wa/oms2WS`,
      cu_id: cuid,
      campaignName: campaignName,
    });
    handleRef.current?.(true);

    const sub = HeartbeatSubject.pipe(
      tap((message) => {
        // console.log(message)
      }),
      timeout(TIMEOUT_DURATION)
    ).subscribe(
      (value) => {},
      (error) => {
        socket.close();
        handleRef.current?.(false);
      }
    );

    return () => {
      sub.unsubscribe();
      socket.close();
    };
  }, [cuid, wsOrderdisConnect, campaignName]);
}

function useConnectQuoteSocket(
  cuid: string | null,
  wsQuotedisConnect: boolean,
  handleQuoteConnect: (state: boolean) => void
) {
  const handleRef = React.useRef(handleQuoteConnect);
  handleRef.current = handleQuoteConnect;
  React.useEffect(() => {
    const TIMEOUT_DURATION = 15 * 1000;
    if (!cuid) {
      return;
    }
    const socket = connectQuoteWebSocket({
      url: `${process.env.REACT_APP_URL}/wa/ws`,
      cu_id: cuid,
    });
    handleRef.current?.(true);

    const sub = QuoteHeartbeatSubject.pipe(
      tap((message) => {
        // console.log(message)
      }),
      timeout(TIMEOUT_DURATION)
    ).subscribe(
      (value) => {},
      (error) => {
        socket.close();
        handleRef.current?.(false);
      }
    );

    return () => {
      sub.unsubscribe();
      socket.close();
    };
  }, [cuid, wsQuotedisConnect]);
}
function useVerifyCheck(cuid: string | null) {
  const {
    loading: VerifyCheckLoading,
    value: checkvalue,
    retry: VerifyCheckRetry,
  } = useAsyncRetry(() => api.verifyCheck({ cu_id: cuid }), [cuid]);
  const devicesVerify = checkvalue?.verified || [];
  const phoneIsVerify = React.useMemo(() => {
    const getSMSVerified = devicesVerify.find((i) => i.v_type === "1");
    const isVerify = getSMSVerified?.status || false;
    return isVerify;
  }, [VerifyCheckLoading]);

  return {
    checkvalue,
    phoneIsVerify,
    VerifyCheckRetry,
    VerifyCheckLoading,
  };
}

function useBellCheck(cuid: string | null, t1: string, t2: string) {
  const { loading, value, retry } = useAsyncRetry(
    () => api.bellCheck({ cu_id: cuid, t1: t1, t2: t2 }),
    [cuid]
  );
  const isBell = React.useMemo(() => {
    const Bell = value?.bell || false;
    return Bell;
  }, [loading]);

  const campaign_active = React.useMemo(() => {
    //console.log("!!!!!!!",value)
    const active =
      value?.err === "1200" ||
      value?.err === "9999" ||
      value?.err === "401" ||
      value === undefined
        ? false
        : true;
    return active;
  }, [loading]);
  const isTimeOut = React.useMemo(() => {
    //console.log("!!!!!!!",value)
    const active = value?.err === "401" ? true : false;
    return active;
  }, [loading]);
  const bellErrorCode = React.useMemo(() => {
    return value?.message || "";
  }, [loading]);
  return {
    retry,
    loading,
    isBell,
    campaign_active,
    isTimeOut,
    bellErrorCode,
  };
}
function useCampaignInfo() {
  const accInfo = (window.parent as any).reactGetLoginInfo();

  const {
    loading,
    value,
    retry: getCampaignRetry,
  } = useAsyncRetry(() => api.getCampaignQuery(), []);

  const defaultCUID = React.useMemo(() => {
    return value?.cu_id || null;
  }, [value]);
  function Formatter(data: CampaignType): CampaignType {
    return {
      code: data.code,
      name: data.name,
      t_open: data.t_open,
      t_close: data.t_close,
      s_timeToe_time: data.s_timeToe_time || "",
      d_start: data.d_start,
      d_end: data.d_end,
      d_start_end: data.d_start_end,
      init_cash: data.init_cash,
      realtime: data.realtime,
      status: data.status,
      action: data.code,
      phone: accInfo?.phone || "",
      email: accInfo?.mail || "",
      m_type: data.m_type,
      school_campaign: data.school_campaign,
      joinSC: data.joinSC,
      mailverifyflag:  data.mailverifyflag,
      mailverify : data.mailverify,
    };
  }
  const Campaign = React.useMemo(() => {
    return value?.campaign ? value?.campaign.map(Formatter) : [];
  }, [loading]);
  const schoolCampaignCode = React.useMemo(() => {
    console.log("schoolCampaignCode", value?.schoolCampaignCode);
    return value?.schoolCampaignCode ? value?.schoolCampaignCode : [];
  }, [loading]);

  return {
    getCampaignRetry,
    defaultCUID,
    loading,
    Campaign,
    schoolCampaignCode,
  };
}
function App() {
  const [checkInfo, setCheckInfo] = useState<boolean>(false);
  const [showMsg, setMsgShow] = useState(false);
  const [modalAction, SetModalAction] = useState(true);
  const [msg, setMsg] = useState("");
  const [w2, setW2] = useState("");

  let userCuid =
    sessionStorage.getItem("cuid") && sessionStorage.getItem("cuid") !== "9999"
      ? sessionStorage.getItem("cuid")
      : null;
  let sessionUserName = sessionStorage.getItem("userName")
    ? sessionStorage.getItem("userName")
    : null;
  let sessionCampaignName = sessionStorage.getItem("code")
    ? sessionStorage.getItem("code")
    : null;
  let sessionInvitationCode = sessionStorage.getItem("inv_code")
    ? sessionStorage.getItem("inv_code")
    : null;

  const [wsOrderdisConnect, setWsOrderConnect] = useState<boolean>(false);
  const [wsQuotedisConnect, setWsQuoteConnect] = useState<boolean>(false);
  const [quoteSessionId, setQuoteSessionId] = useState<string | null>(null);
  const [userName, setUserName] = useState<string>(`${sessionUserName}`);
  const [campaignName, setCampaignName] = useState<string | null>(
    !sessionCampaignName
      ? null
      : sessionCampaignName === "Replay"
      ? "回播體驗"
      : "即時體驗"
  );
  const [code, setCode] = useState<string | null>(null);

  const [cuid, setCuid] = useState<string | null>(userCuid ? userCuid : null);
  const [orderCount, setOrderCount] = useState<number>(0);
  /// if ((window.parent as any).location.href.includes('tradAccount?checkInfo') && checkInfo) {
  const [pageButton, setPageButton] = useState<Page>(
    (window.parent as any).location.href.includes("tradAccount?verify") &&
      !checkInfo
      ? "verify"
      : userCuid
      ? "order"
      : "gameIndex"
  );
  const [mtype, setMtype] = useState<string>("");
  const [invitationCode, setInvitationCode] = useState<string | null>(
    sessionInvitationCode ? sessionInvitationCode : null
  );
  const [togget, setTogger] = useState<boolean>(false);
  const [t1, setT1] = useState<string>(
    dayjs().format("YYYY/MM/DD HH:mm:ss.000")
  );
  const [t2, setT2] = useState<string>("");
  const [userTaskRefresh, setUserTaskRefresh] = React.useState<Boolean>(false);
  const [userTaskList, setUserTaskList] = React.useState<taskListType[] | []>(
    []
  );
  const [userTaskList15, setUserTaskList15] = React.useState<taskListType15[] | []>(
    []
  );
  const [userTaskRefreshTime, setUserTaskRefreshTime] =
    React.useState<string>("");

  const {
    loading: CampaignQueryLoading,
    Campaign: CampaignQuery,
    defaultCUID: defauleCuid,
    schoolCampaignCode,
    getCampaignRetry,
  } = useCampaignInfo();

  const getUserTask = async () => {
    if (!cuid && !defauleCuid) return;
  
    try {
      // 同時發送兩個 API 請求
      const [taskListResponse, taskList15Response] = await Promise.all([
        api.getTaskList({ cu_id: cuid ? cuid : defauleCuid }),
        api.getTaskList15({ cu_id: cuid ? cuid : defauleCuid }),
      ]);
  
      // 處理 getTaskList 的回應
      if (taskListResponse.err === "0000") {
        setUserTaskList(taskListResponse.user_task[0].taskList || []);
        const refreshTime = dayjs(taskListResponse.user_task[0].sysDate).format(
          "YYYY/MM/DD HH:mm:ss"
        );
        setUserTaskRefreshTime(refreshTime);
      } else {
        setUserTaskRefreshTime(taskListResponse.err);
      }
  
      // 處理 getTaskList15 的回應
      if (taskList15Response.err === "0000") {
        setUserTaskList15(taskList15Response.user_task[0].taskList || []);
      } else {
        // 根據需要處理 getTaskList15 的錯誤
        console.error("getTaskList15 error:", taskList15Response.err);
      }
      // console.log(userTaskList);
      // console.log(userTaskList15);
      (window.parent as any).resizeIframe();
    } catch (error) {
      console.error("Error fetching task lists:", error);
    }
  };
  

  React.useEffect(() => {
    if (userTaskRefreshTime !== "TaskMsg") {
      const fetchTask = async () => {
        await getUserTask();
    };
    const timeoutId = setTimeout(() => {
        fetchTask();
    }, 2000); 
    return () => clearTimeout(timeoutId);
}
  }, [cuid, defauleCuid, userTaskRefresh, pageButton]);

  const { checkvalue, phoneIsVerify, VerifyCheckRetry, VerifyCheckLoading } =
    useVerifyCheck(defauleCuid);

  useConnectOrderSocket(cuid, campaignName, wsOrderdisConnect, (state) => {
    setWsOrderConnect(state);
  });
  useConnectQuoteSocket(cuid, wsQuotedisConnect, (state) => {
    setWsQuoteConnect(state);
  });
  const { retry, isBell, campaign_active, isTimeOut, bellErrorCode } =
    useBellCheck(cuid, t1, t2);
  // console.log("campaign_active", campaign_active);
  const [TimeOut, setTimeOut] = useState<boolean>(false);
  React.useEffect(() => {
    const subscriber = QuoteSessionIdSubject.subscribe(
      ({ from, sessionId }) => {
        if (sessionId) {
          setQuoteSessionId(sessionId);
        }
      }
    );
    return () => {
      subscriber.unsubscribe();
    };
  }, [wsQuotedisConnect]);

  React.useEffect(() => {
    if (userCuid) {
      setTogger(!togget);
    }
  }, []);

  const showMsgBox = (msg: string) => {
    if (pageButton !== "gameIndex") {
      return;
    }
    SetModalAction(true);
    setMsg(msg);
    setMsgShow(true);
  };
  //查詢簡訊驗證狀態跳出提醒視窗
  React.useEffect(() => {
    if (checkvalue && checkvalue.w2) {
      setW2(checkvalue.w2);
    }
  }, [checkvalue]);
  React.useEffect(() => {
    if (w2 === "") {
      return;
    }
    if (w2 && !phoneIsVerify) {
      showMsgBox(w2);
    }
  }, [w2]);

  //小鈴鐺每三秒輪詢,查詢委託單狀態
  React.useEffect(() => {
    const firstDate = dayjs().format("YYYY/MM/DD HH:mm:ss.000");
    setT1(firstDate);
  }, []);
  React.useEffect(() => {
    setTimeOut(isTimeOut);
    if (TimeOut === true && campaign_active === false) {
      (window.parent as any).reactLogout(
        `登入閒置已超過20分鐘，請重新登入!! error:${bellErrorCode}`
      );
    }
  }, [isTimeOut, TimeOut]);

  React.useEffect(() => {
    const everySecond = 3;
    if (isBell) {
      setOrderCount(orderCount + 1);
    }

    const creatInt = setInterval(() => {
      if (TimeOut === true && campaign_active === false) {
        return;
      }
      const t1 = dayjs()
        .subtract(everySecond, "second")
        .format("YYYY/MM/DD HH:mm:ss.000");
      const t2 = dayjs().format("YYYY/MM/DD HH:mm:ss.000");
      setT1(t1);
      setT2(t2);
      if (campaign_active) {
        retry();
      }
      setTogger(!togget);
    }, everySecond * 1000);
    return () => {
      clearInterval(creatInt);
    };
  }, [togget]);

  const handleGameCampaign = (
    cuid: string,
    campaignName: string,
    code: string,
    userName: string,
    m_type: string
  ) => {
    setUserName(userName);
    setCuid(cuid);
    setWsOrderConnect(false);
    setCode(code);
    setCampaignName(campaignName);
    setPageButton("account");
    setMtype(m_type);
  };

  const renderPage = (function () {
    const renderGameIndex = (
      <GameIndex
        CampaignQueryLoading={CampaignQueryLoading}
        setUserTaskRefresh={() => {
          setUserTaskRefresh(!userTaskRefresh);
        }}
        refreshTime={userTaskRefreshTime}
        userTaskList={userTaskList} //任務30
        userTaskList15={userTaskList} // 確保這行傳遞了 userTaskList15
        CampaignQuery={CampaignQuery}
        cuid={cuid ? cuid : defauleCuid}
        campaignName={campaignName}
        getCampaignRetry={getCampaignRetry}
        schoolCampaignCode={schoolCampaignCode}
        handleGameCampaign={(cuid, campaignName, code, userName, m_type) => {
          handleGameCampaign(cuid, campaignName, code, userName, m_type);
        }}
      />
    );
    switch (pageButton) {
      case "gameIndex":
        return renderGameIndex;
      case "account":
        if (!cuid) {
          return renderGameIndex;
        }
        return (
          <Account
            cuid={cuid}
            campaign_active={campaign_active}
            code={campaignName}
            campaignName={campaignName}
            userName={userName}
            sessionId={quoteSessionId}
            mtype={mtype}
            handleOninvitationCode={(code) => {
              setInvitationCode(code);
            }}
            refreshTime={userTaskRefreshTime}
            invitationCode={invitationCode}
            continueBell={() => {
              setTogger(!togget);
            }}
          />
        );
      case "order":
        console.log("campaign!!", campaign_active);
        if (!cuid) {
          return renderGameIndex;
        }
        return (
          <Order
            cuid={cuid}
            campaign_active={campaign_active}
            campaignName={campaignName}
            sessionId={quoteSessionId}
            mtype={mtype}
            handleOninvitationCode={(code) => {
              setInvitationCode(code);
            }}
            invitationCode={invitationCode}
            continueBell={() => {
              setTogger(!togget);
            }}
          />
        );
      case "selfSelect":
        if (!cuid) {
          return renderGameIndex;
        }
        return (
          <SelfSelect
            cuid={cuid}
            campaign_active={campaign_active}
            campaignName={campaignName}
            sessionId={quoteSessionId}
            mtype={mtype}
            handleOninvitationCode={(code) => {
              setInvitationCode(code);
            }}
            invitationCode={invitationCode}
            continueBell={() => {
              setTogger(!togget);
            }}
          />
        );
      case "profited":
        if (!cuid) {
          return renderGameIndex;
        }
        return <Profited cuid={cuid} campaignName={campaignName} />;
      case "orderInquire":
        if (!cuid) {
          return renderGameIndex;
        }
        return (
          <OrderInquire
            campaign_active={campaign_active}
            cuid={cuid}
            campaignName={campaignName}
            orderCount={orderCount}
            continueBell={() => {
              setTogger(!togget);
            }}
          />
        );
      case "leaderboard":
        if (!cuid) {
          return renderGameIndex;
        }
        return (
          <Leaderboard
            cuid={cuid}
            campaignName={campaignName}
            userName={userName}
          />
        );
      case "verify":
        return (
          <Verify
            phoneIsVerify={phoneIsVerify}
            w1={checkvalue?.w1 || ""}
            m2={checkvalue?.m2 || ""}
            defauleCuid={defauleCuid}
            showMsg={(msg) => showMsgBox(msg)}
            VerifyCheckRetry={() => VerifyCheckRetry()}
            VerifyCheckLoading={VerifyCheckLoading}
          />
        );
      default:
        return renderGameIndex;
    }
  })();
  const FUNC_TYPE_MAP: Record<string, string> = {
    10: "委託成功",
    11: "委託成功",
    20: "刪單成功",
    21: "刪單失敗",
    30: "改單成功",
    31: "改單失敗",
    90: "委託成交",
  };
  React.useEffect(() => {
    const subscriber = merge(OrderReportMessageSubject).subscribe((message) => {
      message.FUNC !== 90 &&
        toast.info(
          <>
            <h5>{FUNC_TYPE_MAP[message.FUNC]}</h5>
            <div className="toastContain">
              標的：{message.SYM}
              <br />
              價格：{message.P1}
              <br />
              數量：{message.QTY}
            </div>
          </>,
          {
            position: "top-right",
            autoClose: 1300,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          }
        );

      message.FUNC === 90 &&
        toast.success(
          <>
            <h5>{FUNC_TYPE_MAP[message.FUNC]}</h5>
            <div className="toastContain">
              標的：{message.SYM}
              <br />
              價格：{message.P1}
              <br />
              數量：{message.QTY}
            </div>
          </>,
          {
            position: "top-right",
            autoClose: 1300,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          }
        );
    });
    return () => {
      subscriber.unsubscribe();
    };
  }, [orderCount]);

  return (
    <div className="App">
      {/* page-Nav */}
      <Container className="position-relative p-2">
        <Navigation
          pageButton={pageButton}
          onPageButtonClick={(page) => {
            setPageButton(page);
          }}
          orderCount={orderCount}
          onorderCountClick={() => {
            setOrderCount(0);
          }}
          cuid={cuid}
          verify={phoneIsVerify}
          code={code || ""}
        />
      </Container>
      {/* page-Container */}
      <div className="page-background">
        <Container className="position-relative p-2">{renderPage}</Container>
      </div>

      {/* page-foot */}
      <div className="footToast">
        <ToastContainer limit={2} rtl={false} newestOnTop={false} />
      </div>
      <div className="ver">{process.env.REACT_APP_VER}</div>
      <Modal
        show={showMsg}
        onHide={() => setMsgShow(false)}
        backdrop="static"
        keyboard={false}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>{msg}</Modal.Body>
        <Modal.Footer>
          <Button
            className="modal-rounded"
            variant={modalAction ? "secondary" : "primary"}
            onClick={() => setMsgShow(false)}>
            {modalAction ? "以後再說" : "確認"}
          </Button>
          {modalAction && (
            <Button
              className="modal-rounded"
              variant="primary"
              onClick={() => {
                setPageButton("verify");
                setMsgShow(false);
              }}>
              立刻去驗證
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default App;
